<template>
  <section class="card">
    <div class="card-header">
      <h5 class="mb-0 text-black" v-if="title">
        <strong>{{ title }}</strong>
      </h5>
      <slot name="header"></slot>
    </div>
    <div class="card-body">
      <slot></slot>
    </div>
    <div class="card-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Card',
    props: {
      title: {
        type: String,
        required: false,
        default: null,
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/Card.vue